import { WithTeamsAuth } from "./auth-hooks/WithTeamsAuth";
import { WithWebAuth } from "./auth-hooks/WithWebAuth";
import { useEffect } from "react";
import { PUBLIC_ROUTES } from "@app/App";
import { redirectTo, selectCurrentUser } from "../store/auth.duck";
import { useDispatch, useSelector } from "react-redux";
import { isOnTeamsTabAuthPage } from "@features/auth/pages/login/LoginWithAzureInTeamsTab";
import { isInTeams } from '@shared/utils/TeamsUtils';
import { consumePostLoginRedirect } from "@shared/utils/UrlUtils";

export function WithAuth() {
  const dispatch = useDispatch();
  const user = useSelector(selectCurrentUser);

  useEffect(() => {
    if (!!user && PUBLIC_ROUTES.includes(window.location.pathname) && window.location.pathname !== "/login/tab-auth") {
      if (window.location.pathname === "/debug/msal") {
        return;
      }
      // If they were bounced here from a protected deep link, send them back to it.
      dispatch(redirectTo(consumePostLoginRedirect() ?? '/whereabouts/team'));
    }
  }, [dispatch, user]);

  if (isOnTeamsTabAuthPage()) {
    console.log('No auth on teams tab page');
    return;
  }

  if (isInTeams()) {
    WithTeamsAuth();
  } else {
    WithWebAuth();
  }
}
